import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import PrivateRoute from './components/PrivateRoutes';
import { isAuthenticated, getPerfil } from './services/auth';

import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import QrCode from './pages/QRCode';
import App from './pages/App';
// import { ScrollToTop } from './components/ScrollToTop';

import Perfil from './pages/efetivo/Perfil';
import MeuPerfil from './pages/efetivo/MeuPerfil';
import Editar from './pages/efetivo/Editar';
import EditarLotacao from './pages/efetivo/EditarLotacao';

import Usuarios from './pages/efetivo/Usuarios';
import AddUsuario from './pages/efetivo/AddUsuario';

import Alocacao from './pages/Alocacao';

// import Sgo from './pages/Sgo';

import Patrimonio from './pages/Patrimonio/ListaPatrimonio';
import AddPatrimonio from './pages/Patrimonio/AddPatrimonio';
import VisualizarPatrimonio from './pages/Patrimonio/VisualizarPatrimonio';

import EscalaCalendario from './pages/Calendario';

import Lotacao from './pages/Lotacao';

import ControlePresenca from './pages/ControlePresenca';

import EfetivoEstatisticas from './pages/efetivo/Estatisticas';
import FrequenciaAuditoria from './pages/FrequenciaAuditoria';

import ServicoEstatisticas from './pages/ServicoEstatisticas';
import Adm from './pages/Adm';
import Demo from './pages/Demo';
import Estrategico from './pages/Estrategico';
import Operacional from './pages/Operacional';
import Operador from './pages/Operador';

//
//
//
// ROTAS DE RH
//
//
//
//
import rhVagas from './pages/RH/Vagas';
import rhLista from './pages/RH/Lista';

//
//
//
// ROTAS DE ABORDAGEM
//
//
//
// import RotasAbordagem from './pages/SGO/routes';
import AddAbordagem from './pages/SGO/AddAbordagem';
import ListarAbordagens from './pages/SGO/ListarAbordagens';
import ParticipacoesAbordagens from './pages/SGO/ParticipacoesAbordagens';
import Abordagens from './pages/SGO/Abordagens';
import Imprimir from './pages/SGO/Abordagens/Imprimir';
import RelatorioDia from './pages/SGO/RelatorioDia';
import RelatorioDiaEmissoes from './pages/SGO/RelatorioDiaEmissoes';
import AddOcorrencia from './pages/SGO/AddOcorrencia';
import VerAbordagem from './pages/SGO/VerAbordagem';
import InsereItens from './pages/SGO/InsereItens';
import RevisaoAbordagens from './pages/SGO/RevisaoAbordagens';

//
//
// missao
//
//

import Inteligencia from './pages/SGO/Inteligencia';
import AddRelato from './pages/Inteligencia/AddRelato';
import Relatos from './pages/Inteligencia/Relatos';
import RelatorioTecnico from './pages/Inteligencia/RelatorioTecnico';
import RelatoriosTecnicos from './pages/Inteligencia/RelatoriosTecnicos';

// const PrivateRoute = ({ component: Component, ...rest }) => (
//   <Route
//     {...rest}
//     render={props =>
//       isAuthenticated() ? (
//         <>
//           {window.scrollTo(0, 0)}
//           <Component {...props} />
//         </>
//       ) : (
//         <Redirect to={{ pathname: '/', state: { from: props.location } }} />
//       )
//     }
//   />
// );

import AddAssunto from './pages/LPD/AddAssunto';
import ListaLPD from './pages/LPD/ListaLPD';
import addLpd from './pages/LPD/AddLpd';

// AVALIAÇÃO
import EfetivoAvaliacao from './pages/EfetivoAvaliacao';

// DADOS OPERACIONAIS
import AddDadosOperacionais from './pages/SGO/DadosOperacionais/Assuntos';
// import DashboardDadosOperacionais from './pages/SGO/DadosOperacionais/Dashboard';
import DadosOperacionais from './pages/SGO/DadosOperacionais/Lista';

// ROTAS DE FROTAS
import Frotas from './routes/Frotas';
import PerfisAcesso from './pages/Administracao/Perfis';
import Rotinas from './pages/Administracao/Rotinas';
import Denuncias from './pages/Denuncias';

//FERIAS
import Ferias from './pages/Ferias';

// AUTO INFRACAO RECEITA
import ImportarAutosInfracao from './pages/DadosEstatisticos/ImportarAutosInfracao';
import ListarAutosInfracao from './pages/DadosEstatisticos/ListarAutosInfracao';
import IndicadoresPPA from './pages/DadosEstatisticos/IndicadoresPPA';
import PainelEfetivo from './pages/Paineis/Efetivo';
import PainelAutosInfracao from './pages/Paineis/AutosInfracao';
import PainelFiscalizacao from './pages/Paineis/Fiscalizacao';
import DashboardDetalhado from './pages/DadosEstatisticos/DashboardDetalhado';

//
import Alerta from './pages/Notificacao/Alerta';

// CONTRA INTELIGENCIA: reusa as MESMAS telas do RT, injetando o tipo.
// Wrappers em module scope (nao dentro do componente Routes) p/ nao remontar.
const CiRelatorioTecnico = props => (
  <RelatorioTecnico {...props} tipo="CONTRA_INTELIGENCIA" />
);
const CiRelatoriosTecnicos = props => (
  <RelatoriosTecnicos {...props} tipo="CONTRA_INTELIGENCIA" />
);

// RELINT: reusa as MESMAS telas do RT, injetando o tipo.
const RelintCriar = props => (
  <RelatorioTecnico {...props} tipo="RELINT" />
);
const RelintLista = props => (
  <RelatoriosTecnicos {...props} tipo="RELINT" />
);

// RELINT restrito a PROPRIA GERENCIA (ACL de escopo): mesmas telas do RELINT,
// com a prop restritoGerencia (rotas de criacao/retorno proprias). O filtro
// por gerencia e FORCADO no backend.
const RelintGerenciaCriar = props => (
  <RelatorioTecnico {...props} tipo="RELINT" restritoGerencia />
);
const RelintGerenciaLista = props => (
  <RelatoriosTecnicos {...props} tipo="RELINT" restritoGerencia />
);

// RELINT dentro da CONTRA INTELIGENCIA: mesmo layout do RELINT, tipo/serie
// e menu proprios (modulo Contra Inteligencia).
const CiRelintCriar = props => (
  <RelatorioTecnico {...props} tipo="RELINT_CI" />
);
const CiRelintLista = props => (
  <RelatoriosTecnicos {...props} tipo="RELINT_CI" />
);

// PEDIDO DE BUSCA: mesmas telas do RT, sem Dinamica (tipo proprio).
const PedidoBuscaCriar = props => (
  <RelatorioTecnico {...props} tipo="PEDIDO_BUSCA" />
);
const PedidoBuscaLista = props => (
  <RelatoriosTecnicos {...props} tipo="PEDIDO_BUSCA" />
);
// PEDIDO DE BUSCA na CONTRA INTELIGENCIA: mesmo layout, tipo/serie proprios.
const CiPedidoBuscaCriar = props => (
  <RelatorioTecnico {...props} tipo="PEDIDO_BUSCA_CI" />
);
const CiPedidoBuscaLista = props => (
  <RelatoriosTecnicos {...props} tipo="PEDIDO_BUSCA_CI" />
);

// ORDEM DE BUSCA: identica ao Pedido de Busca (sem Dinamica), tipo/serie proprios.
const OrdemBuscaCriar = props => (
  <RelatorioTecnico {...props} tipo="ORDEM_BUSCA" />
);
const OrdemBuscaLista = props => (
  <RelatoriosTecnicos {...props} tipo="ORDEM_BUSCA" />
);
// ORDEM DE BUSCA na CONTRA INTELIGENCIA: mesmo layout, tipo/serie proprios.
const CiOrdemBuscaCriar = props => (
  <RelatorioTecnico {...props} tipo="ORDEM_BUSCA_CI" />
);
const CiOrdemBuscaLista = props => (
  <RelatoriosTecnicos {...props} tipo="ORDEM_BUSCA_CI" />
);

// RELATORIO DE AGENTE: RT completo (com Dinamica), tipo/serie proprios.
const RelatorioAgenteCriar = props => (
  <RelatorioTecnico {...props} tipo="RELATORIO_AGENTE" />
);
const RelatorioAgenteLista = props => (
  <RelatoriosTecnicos {...props} tipo="RELATORIO_AGENTE" />
);
// RELATORIO DE AGENTE na CONTRA INTELIGENCIA: mesmo layout, tipo/serie proprios.
const CiRelatorioAgenteCriar = props => (
  <RelatorioTecnico {...props} tipo="RELATORIO_AGENTE_CI" />
);
const CiRelatorioAgenteLista = props => (
  <RelatoriosTecnicos {...props} tipo="RELATORIO_AGENTE_CI" />
);

const Routes = () => (
  <BrowserRouter>
    {/* <ScrollToTop /> */}
    <Switch>
      <Route exact path="/" component={SignIn} />

      {/* <Route path="/signup" component={SignUp} /> */}
      <PrivateRoute path="/qrcode" component={QrCode} />
      <PrivateRoute path="/app" component={App} />
      {/* MENU - VISUALIZA PROPRIO PERFIL */}
      <PrivateRoute path="/meu-perfil" component={MeuPerfil} />

      {/*CARD SGE -- SGE - ROTAS DE CONTROLE DE USUARIOS */}
      <PrivateRoute exact path="/usuarios" component={Usuarios} />
      <PrivateRoute path="/usuario/add" component={AddUsuario} />
      <PrivateRoute path="/usuarios/:id" component={Perfil} />
      <PrivateRoute path="/editar/:id" component={Editar} />
      <PrivateRoute path="/editar-lotacao/:id" component={EditarLotacao} />
      <PrivateRoute
        path="/efetivo-estatisticas"
        component={EfetivoEstatisticas}
      />

      {/*CARD ALOCACAO -- ROTAS DE CONTROLE DE GERENCIA */}
      <PrivateRoute path="/lotacao" component={Lotacao} />
      <PrivateRoute path="/alocacao" component={Alocacao} />

      {/* CARD GESTAO DE SERVICO  */}
      <PrivateRoute path="/escala-calendario" component={EscalaCalendario} />
      <PrivateRoute path="/controle-de-presenca" component={ControlePresenca} />
      <PrivateRoute
        path="/frequencia-auditoria"
        component={FrequenciaAuditoria}
      />
      <PrivateRoute
        path="/servico-estatisticas"
        component={ServicoEstatisticas}
      />

      {/* <PrivateRoute path="/add-ocorrencia" component={Sgo} /> */}

      <PrivateRoute path="/add-patrimonio" component={AddPatrimonio} />
      <PrivateRoute path="/patrimonio" component={Patrimonio} />

      <PrivateRoute
        path="/visualizar-patrimonio"
        component={VisualizarPatrimonio}
      />

      <PrivateRoute path="/adm" component={Adm} />
      <PrivateRoute path="/estrategico" component={Estrategico} />
      <PrivateRoute path="/operacional" component={Operacional} />
      <PrivateRoute path="/operador" component={Operador} />
      <PrivateRoute path="/demo" component={Demo} />
      {/* <PrivateRoute path="/add-ocorrencia/:id" component={AddOcorrencia} /> */}
      {/* ROTAS DE ABORDAGENS */}
      <PrivateRoute path="/add-abordagem" component={AddAbordagem} />
      <PrivateRoute path="/minhas-abordagens" component={ListarAbordagens} />
      <PrivateRoute
        path="/participacoes-abordagens"
        component={ParticipacoesAbordagens}
      />
      <PrivateRoute path="/abordagens" component={Abordagens} />
      <PrivateRoute path="/revisao-abordagens" component={RevisaoAbordagens} />

      {/* [#256] a tela virou "Relatório da abordagem", mas a ROTA continua esta:
          a autorização é por rota e quem a concede é o backend, em
          utils/derivaAcessos.js. Renomear aqui derruba a tela com "rota não
          autorizada". */}
      <PrivateRoute
        path="/imprime-abordagem/:abordagem_id"
        component={Imprimir}
      />

      <PrivateRoute path="/relatorio-dia" component={RelatorioDia} />
      <PrivateRoute
        path="/relatorio-dia-emissoes"
        component={RelatorioDiaEmissoes}
      />

      <PrivateRoute path="/insere-item" component={InsereItens} />
      {/* <PrivateRoute
        path="/edita-abordagem/:abordagem_id"
        component={EditarAbordagem}
      /> */}
      <PrivateRoute
        path="/add-ocorrencia/:abordagem_id"
        component={AddOcorrencia}
      />
      <PrivateRoute path="/abordagem/:abordagem_id" component={VerAbordagem} />

      <PrivateRoute path="/inteligencia/abordagem" component={Inteligencia} />

      <PrivateRoute path="/rh/vagas" component={rhVagas} />
      <PrivateRoute path="/rh-lista" component={rhLista} />

      <PrivateRoute path="/lpd-assunto/adicionar" component={AddAssunto} />
      <PrivateRoute path="/lpd" exact component={ListaLPD} />
      <PrivateRoute path="/lpd-criar" component={addLpd} />

      <PrivateRoute path="/relatos-criar" component={AddRelato} />
      <PrivateRoute path="/relatos" component={Relatos} />
      <PrivateRoute
        path="/relatorio-tecnico-criar"
        component={RelatorioTecnico}
      />
      <PrivateRoute
        path="/relatorios-tecnicos"
        component={RelatoriosTecnicos}
      />

      {/* CONTRA INTELIGENCIA (mesmas telas do RT, tipo proprio). Rotas
          DIRETAS antes de <Frotas /> (regra do Switch do projeto). */}
      <PrivateRoute
        path="/ci-relatorio-tecnico-criar"
        component={CiRelatorioTecnico}
      />
      <PrivateRoute
        path="/ci-relatorios-tecnicos"
        component={CiRelatoriosTecnicos}
      />

      {/* RELINT (mesmas telas do RT, tipo proprio) */}
      <PrivateRoute path="/relint-criar" component={RelintCriar} />
      <PrivateRoute path="/relints" component={RelintLista} />

      {/* RELINT restrito a propria gerencia (ACL de escopo) */}
      <PrivateRoute
        path="/relint-gerencia-criar"
        component={RelintGerenciaCriar}
      />
      <PrivateRoute path="/relints-gerencia" component={RelintGerenciaLista} />

      {/* RELINT na CONTRA INTELIGENCIA (mesmo layout do RELINT, tipo proprio) */}
      <PrivateRoute path="/ci-relint-criar" component={CiRelintCriar} />
      <PrivateRoute path="/ci-relints" component={CiRelintLista} />

      {/* PEDIDO DE BUSCA (Inteligencia) */}
      <PrivateRoute path="/pedido-busca-criar" component={PedidoBuscaCriar} />
      <PrivateRoute path="/pedidos-busca" component={PedidoBuscaLista} />

      {/* PEDIDO DE BUSCA (Contra Inteligencia) */}
      <PrivateRoute path="/ci-pedido-busca-criar" component={CiPedidoBuscaCriar} />
      <PrivateRoute path="/ci-pedidos-busca" component={CiPedidoBuscaLista} />

      {/* ORDEM DE BUSCA (Inteligencia) */}
      <PrivateRoute path="/ordem-busca-criar" component={OrdemBuscaCriar} />
      <PrivateRoute path="/ordens-busca" component={OrdemBuscaLista} />

      {/* ORDEM DE BUSCA (Contra Inteligencia) */}
      <PrivateRoute path="/ci-ordem-busca-criar" component={CiOrdemBuscaCriar} />
      <PrivateRoute path="/ci-ordens-busca" component={CiOrdemBuscaLista} />

      {/* RELATORIO DE AGENTE (Inteligencia) */}
      <PrivateRoute path="/relatorio-agente-criar" component={RelatorioAgenteCriar} />
      <PrivateRoute path="/relatorios-agente" component={RelatorioAgenteLista} />

      {/* RELATORIO DE AGENTE (Contra Inteligencia) */}
      <PrivateRoute path="/ci-relatorio-agente-criar" component={CiRelatorioAgenteCriar} />
      <PrivateRoute path="/ci-relatorios-agente" component={CiRelatorioAgenteLista} />

      <PrivateRoute path="/efetivo-avaliacao" component={EfetivoAvaliacao} />

      <PrivateRoute
        path="/operacionais-assuntos"
        component={AddDadosOperacionais}
      />
      <PrivateRoute path="/dados-operacionais" component={DadosOperacionais} />
      {/* <PrivateRoute path="/dashboard" component={DashboardDadosOperacionais} /> */}
      <PrivateRoute path="/denuncias" component={Denuncias} />
      <PrivateRoute path="/ferias" component={Ferias} />
      <PrivateRoute path="/alertas" component={Alerta} />
      
      {/* AUTO INFRACAO RECEITA */}
      <PrivateRoute 
        path="/dados-estatisticos/importar-autos" 
        component={ImportarAutosInfracao} 
      />
      <PrivateRoute
        path="/dados-estatisticos/autos-infracao"
        component={ListarAutosInfracao}
      />
      <PrivateRoute
        path="/dashboard-detalhado"
        component={DashboardDetalhado}
      />

      {/* INDICADORES DO PPA (I0153, I0154, I0155)
          A rota casa com a `funcionalidade` '/indicadores' criada pela migration
          20260814100000 — é ela que faz o item aparecer no menu, montado a partir
          dos acessos do usuário. */}
      <PrivateRoute path="/indicadores" component={IndicadoresPPA} />

      {/* PAINEL DE EFETIVO — a rota casa com a `funcionalidade` '/painel-efetivo'
          criada pela migration 20261006100100 (sem concessão: atribuir pela tela
          de perfis). Precisa ficar antes de <Frotas />. */}
      <PrivateRoute path="/painel-efetivo" component={PainelEfetivo} />
      {/* PAINEL DE AUTOS DE INFRAÇÃO — a rota casa com a `funcionalidade`
          '/painel-autos-infracao' (migration 20261015100000), sem concessão. */}
      <PrivateRoute path="/painel-autos-infracao" component={PainelAutosInfracao} />
      {/* CONSOLIDADO DA FISCALIZAÇÃO (#404) — casa com a `funcionalidade`
          '/painel-fiscalizacao' (migration 20261103100000), sem concessão. */}
      <PrivateRoute path="/painel-fiscalizacao" component={PainelFiscalizacao} />

      {/* Administracao: rota DIRETA (antes de <Frotas />, que e um wrapper sem
          `path` e num <Switch> "engole" o match, impedindo rotas apos ele). */}
      <PrivateRoute path="/admin-perfis" component={PerfisAcesso} />

      {/* Agendador de rotinas. A rota casa com a funcionalidade '/rotinas'
          (modulo 13, Administracao) criada pela migration 20260825130000 — e'
          ela que faz o item aparecer no menu, montado a partir dos acessos do
          usuario (NavBar/index.js). */}
      <PrivateRoute path="/rotinas" component={Rotinas} />

      <Frotas />

      <Route path="*" component={() => <h1>Page not found</h1>} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
